import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { take, takeUntil, tap } from 'rxjs/operators';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ComprobarClientesService } from '../../../../../app/core/providers/services/comprobar-clientes/comprobar-clientes.service';
import { MunicipiosRecuperarService } from '../../../../../app/core/providers/services/municipios-recuperar/municipios-recuperar.service';
import { CommonService } from '../../../../core/providers/forms/common.service';
import { SectoresService } from '../../../../core/providers/services/sectores/sectores.service';
import InsuredDataComponentUtils from './insured-data.component-utils';
import { Numbers } from 'src/app/utils/constants';
import { PostPardotService } from 'src/app/core/providers/services/pardot-post/pardot-post.service';

@Component({
  selector: 'app-insured-data',
  templateUrl: './insured-data.component.html',
  styleUrls: ['./insured-data.component.scss']
})
export class InsuredDataComponent implements OnInit {

  @Input() FORM_DATA: FormGroup;
  @Input() FORM_CONFIG: any;
  @Input() STEP: any;

  @Output() CLICK_BTN: EventEmitter<'back' | 'next'> = new EventEmitter();
  @Output() INSURED_CHOOSED: EventEmitter<'Particular' | 'Empresa'> = new EventEmitter();
  finish = new Subject();

  @ViewChild('selectType', { static: false }) selecttype: any;
  @ViewChild('numType', { read: ElementRef, static: false }) inputtype: ElementRef;
  @ViewChild('inputN', { read: ElementRef, static: false }) inputN: ElementRef;
  @ViewChild('inputFS', { read: ElementRef, static: false }) inputFS: ElementRef;
  @ViewChild('inputEmail', { read: ElementRef, static: false }) inputEmail: ElementRef;
  @ViewChild('inputP', { read: ElementRef, static: false }) inputP: ElementRef;
  @ViewChild('inputD', { read: ElementRef, static: false }) inputD: ElementRef;
  @ViewChild('zipcode', { read: ElementRef, static: false }) inputZ: ElementRef;
  @ViewChild('inputC', { static: false }) selectC: any;

  formDataValue: any;
  typeOwner: 'Particular' | 'Empresa';
  insureSelected: { name: string, chosed: string };
  currentStep = 0;
  cpchange: { name: string, value: any };
  typeChange: { name: string, value: any };
  sectorchange: { name: string, value: any };
  bodyValue: {};
  disabledSec = false;
  disabledRazSo = false;
  disabledEmail = false;
  disabledPhone = false;
  disabledDir = false;
  disabledCP = false;
  disabledMuni = false;
  disabledProv = false;
  showLegalCompany = false;
  Utils: any;

  /**
   * @ignore
   */
  constructor(
    private readonly commons: CommonService,
    private municipalitySrv: MunicipiosRecuperarService,
    private sectorsSrv: SectoresService,
    private clients: ComprobarClientesService,
    private gtmService: GoogleTagManagerService,
    private pardotSrv: PostPardotService
  ) {
    this.commons = commons;
    this.municipalitySrv = municipalitySrv;
    this.sectorsSrv = sectorsSrv;
    this.clients = clients;
    this.gtmService = gtmService;
    this.pardotSrv = pardotSrv;
    this.Utils = new InsuredDataComponentUtils(this.commons);
  }

  /**
   * @description Metodo de inicio
   */
  ngOnInit() {
    this.currentStep = this.STEP;
    this.initSectors();
    this.Utils.setValidator(this.FORM_DATA, this.FORM_CONFIG);
    this.setDefaultValueTypeOwner();
    this.getProductChoosed();
    this.initObs();
    window.scrollTo(0, 0);
  }
  /**
   * @description Recupera la lista de sectores
   */
  initSectors(): void {
    this.sectorsSrv.getSectors()
      .pipe(take(1))
      .subscribe((sectors) => {
        this.FORM_CONFIG.bussines.companySector.options.list = sectors;
        this.formDataValue.sectorList = sectors;
      });
  }

  /**
   * changePrefix
   */
  changePrefix(): void {
    this.Utils.changePrefixUtils(this.FORM_DATA.value.individualTravelAsistance, this.FORM_DATA.value.sportTravelAsistance,
      this.FORM_DATA.value.particularTravelAsistance, this.FORM_DATA.value.incomingStudentsTravelAsistance);
    this.FORM_DATA.get([this.insureSelected.chosed, 'insuredData', 'telephone']).setValue('');
  }

  /**
   * @description Recupera el tipo de formulario
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {
      this.insureSelected = this.FORM_DATA.get('insureSelected').value;
      this.formDataValue = this.FORM_DATA.get(this.insureSelected.chosed).value;
      this.Utils.getProductChoosedUtils(this.FORM_DATA.get(this.FORM_CONFIG.documentType.linkFormPath).value,
        this.FORM_DATA.get(this.FORM_CONFIG.documentType.linkFormPath).value.name);
    }
  }
  /**
   * @description Datos del tomador
   */
  setDefaultValueTypeOwner(): void {
    if (this.FORM_DATA && this.FORM_CONFIG) {
      this.typeOwner = this.FORM_DATA.get(this.FORM_CONFIG.typeOwner.linkFormPath).value;
      if (!this.typeOwner) {
        this.FORM_DATA
          .get(this.FORM_CONFIG.typeOwner.linkFormPath)
          .setValue(this.FORM_CONFIG.typeOwner.value);
      }
    }
  }
  /**
   * @description Definición inicial del paso
   */
  initObs(): void {
    this.FORM_DATA.get(this.insureSelected.chosed).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
        })
      ).subscribe();
    this.FORM_DATA.get(this.FORM_CONFIG.documentType.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          this.linkFormPathValueChanges(el);
        })
      ).subscribe();

    this.FORM_DATA.get(this.FORM_CONFIG.documentNumber.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          const auxValue: any = el;
          if (this.FORM_DATA.get(this.FORM_CONFIG.documentType.linkFormPath).value.name === 'CIF' && auxValue !== '' &&
              auxValue.length >= Numbers.number9) {
            this.getDataBD();
          }
        })
      ).subscribe();

    this.FORM_DATA.get([this.insureSelected.chosed, 'insuredData', 'telephone']).setValue('');
  }
  /**
   * @description  linkFormPathValueChanges
   * @params el
   */
  linkFormPathValueChanges(el: any): void {
    const auxValue: any = el;
    const auxValueNum: any = this.FORM_DATA.get(this.FORM_CONFIG.documentNumber.linkFormPath).value;
    let isPrevious = false;
    if (localStorage.getItem('next-step3') !== null) { isPrevious = true; }
    if (auxValue.name === 'CIF' && this.Utils.getInsuredChoosed(this.FORM_DATA, this.FORM_CONFIG) === 'Empresa') {
      this.Utils.enableInputs([this.showLegalCompany, this.Utils.disabledEmpApe1, this.Utils.disabledEmpApe2]);
    } else if (this.disabledRazSo) {
      this.showLegalCompany = false;
      this.enableData();
    } else {
      this.Utils.enableInputs([this.showLegalCompany, this.Utils.disabledEmpApe1, this.Utils.disabledEmpApe2]);
    }
    if (auxValueNum !== '' && !isPrevious) {
      this.FORM_DATA.get(this.FORM_CONFIG.documentNumber.linkFormPath).setValue('');
    }
    auxValueNum.toString();
    if (auxValue !== null && auxValue.name === 'CIF' && auxValueNum !== '' && auxValueNum.length >= Numbers.number9) {
      this.getDataBD();
    }
    if (isPrevious) {
      localStorage.removeItem('next-step3');
    }
  }

  /**
   * @description botón siguiente o anterior
   */
  public clickButton(ev: 'back' | 'next'): void {
    const auxTypeVal: any = this.FORM_DATA.get(this.FORM_CONFIG.documentType.linkFormPath).value;
    if (ev === 'next' && auxTypeVal && auxTypeVal.name === 'NIF' &&
        this.Utils.checkDocumentBlur(this.FORM_CONFIG.documentNumber.linkFormPath, this.FORM_DATA, this.FORM_CONFIG)) {
        this.getCheckClient();
    } else if (ev === 'next' && auxTypeVal && auxTypeVal.name !== 'NIF') {
      this.typeChange = { name: 'typeDocSend', value: 'valid' };
      this.Utils.datalayer2(this.FORM_DATA, this.gtmService);
      this.Utils.datalayer(this.FORM_DATA, this.gtmService);
      localStorage.setItem('next-step3', 'true');
      this.CLICK_BTN.emit(ev);
      this.pardotPost();
    } else if (ev === 'next') {
      this.typeChange = { name: 'typeDocSend', value: 'error' };
    } else {
      localStorage.setItem('prev-step2', 'true');
      this.Utils.removeValidator(this.FORM_DATA, this.FORM_CONFIG);
      this.CLICK_BTN.emit(ev);
    }
  }

  /**
   * @description Pardot - realizar envío de datos a salesforce mediante middleware
   */
  pardotPost(): void {
    this.formDataValue = this.FORM_DATA.get(this.insureSelected.chosed).value;
    let razonSocialValue = '';
    let nombreValue = '';
    if (this.formDataValue.insuredData.typeOwner === 'Particular') {
      nombreValue = this.formDataValue.insuredData.particular.name;
    } else {
      razonSocialValue = this.formDataValue.insuredData.bussines.direction;
      nombreValue = this.formDataValue.insuredData.bussines.direction;
    }
    let paisArray: any = this.Utils.setPaisValuePardot(this.insureSelected.chosed, this.formDataValue.insuredData.country.name,
      this.formDataValue.insuredData.country);
    if (paisArray.name !== undefined) {
      paisArray = paisArray.name;
    }
    const body2: any = {
      aceptarConsentimiento: this.Utils.aceptarConstentimiento(parseInt(
        this.formDataValue.termsList[Numbers.number2].Aceptacion, Numbers.number10)),
      datosPersonales: {
        destino: this.Utils.setDestinoPardot(this.formDataValue.countryDestiny, this.formDataValue.countryDestiny.name,
          this.formDataValue.countryDestinyI),
        email: this.formDataValue.insuredData.email,
        fechaInicio: this.Utils.setFechaValuePardot(this.formDataValue.dateStart),
        fechaFin: this.Utils.setFechaValuePardot(this.formDataValue.dateEnd),
        nombre: nombreValue,
        origen: this.Utils.setOrigenPardot(this.formDataValue.countryOrigin.name, this.formDataValue.countryOrigin),
        telefono: this.formDataValue.insuredData.telephone,
        primerApellido: this.formDataValue.insuredData.firstSurname,
        segundoApellido: this.formDataValue.insuredData.secondSurname,
        razonSocial: razonSocialValue
      },
      documentoIdentidad: {
        codigo: this.Utils.setDocumentoIdentidadCodigoPardot(this.formDataValue.insuredData.documentType.name),
        numero: this.formDataValue.insuredData.documentNumber
      },
      direccion: {
        codigoPostal: this.formDataValue.insuredData.postalCode,
        direccion: this.formDataValue.insuredData.direction,
        municipio: this.formDataValue.insuredData.municipality.name,
        pais: paisArray,
        provincia: this.formDataValue.insuredData.province

      },
      numeroViajeros: parseInt(this.formDataValue.numberOfInsured.name, Numbers.number10),
      interesEnProducto: this.FORM_DATA.get('insureSelected').value.name
    };

    this.pardotSrv.postPostPardot(body2)
      .pipe(take(1))
      .subscribe((response: any) => {
      },
        (error) => {
          console.error(error);
      });
  }

  /**
   * @description emitInsuredChoosed
   * @param ev Particular | Empresa
   */
  public emitInsuredChoosed(ev: 'Particular' | 'Empresa'): void {
    if (this.FORM_DATA) {
      this.FORM_DATA.get(this.FORM_CONFIG.typeOwner.linkFormPath).setValue(ev);
      this.INSURED_CHOOSED.emit(ev);
      this.Utils.setValidator(this.FORM_DATA, this.FORM_CONFIG);
      setTimeout(() => {
        this.Utils.checkEnableCompany(this.FORM_DATA, this.FORM_CONFIG);
      }, Numbers.number100);
    }
  }

  /**
   * @description recuperar los valores del servicio municipio
   * @param code number
   */
  getMunicipality(code: number): void {
    const dataSpain: any = [];
    dataSpain.push({ id: Numbers.number67, name: 'España', code: 'España' });
    this.municipalitySrv.getMunicipality(code)
      .pipe(take(1))
      .subscribe((municipality: any) => {
        if (municipality !== null && municipality.length > 1) {
          this.Utils.changeMunicipality(municipality, dataSpain);
        } else if (municipality !== null && municipality.length <= 1) {
          this.Utils.munichange = { name: 'municipio', value: municipality[0] };
          this.Utils.provchange = { name: 'provincia', value: municipality[0].Des_Provincia };
          this.Utils.countrychange = { name: 'country', value: dataSpain[0] };
          this.FORM_DATA.get([this.insureSelected.chosed, 'insuredData', 'provinceId']).setValue(municipality[0].Id_Provincia);
        } else {
          this.cpchange = { name: 'cp', value: 'error' };
          this.Utils.showModalDialog();
        }
      });
  }

  /**
   * @description getCheckClient
   */
  getCheckClient(): void {
    let auxValueName = '';
    const auxValueNum: string = this.FORM_DATA.get(this.FORM_CONFIG.documentNumber.linkFormPath).value;
    auxValueNum.toString();
    if (this.Utils.getInsuredChoosed(this.FORM_DATA, this.FORM_CONFIG) === 'Particular') {
      auxValueName = this.FORM_DATA.get(this.FORM_CONFIG.particular.name.linkFormPath).value;
    } else {
      auxValueName = this.FORM_DATA.get(this.FORM_CONFIG.bussines.direction.linkFormPath).value;
    }
    const data: any = {
      cif: auxValueNum,
      nombre: auxValueName,
      apellido1: this.FORM_DATA.get(this.FORM_CONFIG.firstSurname.linkFormPath).value
    };
    if (auxValueNum.length >= Numbers.number9) {
      this.clients.getCheckClients(data)
        .pipe(take(1))
        .subscribe((client) => {
          if (client.idCliente === 0) {
            this.FORM_DATA.get(this.FORM_CONFIG.firstSurname.linkFormPath).setValue('');
            if (this.Utils.getInsuredChoosed(this.FORM_DATA, this.FORM_CONFIG) === 'Particular') {
              this.FORM_DATA.get(this.FORM_CONFIG.particular.name.linkFormPath).setValue('');
            } else {
              this.FORM_DATA.get(this.FORM_CONFIG.bussines.direction.linkFormPath).setValue('');
            }
            this.Utils.showModalDialog2();
          } else {
            // Enviamnos al siguiente paso
            this.typeChange = { name: 'typeDocSend', value: 'valid' };
            this.Utils.datalayer2(this.FORM_DATA, this.gtmService);
            this.Utils.datalayer(this.FORM_DATA, this.gtmService);
            localStorage.setItem('next-step3', 'true');
            this.CLICK_BTN.emit('next');
            this.pardotPost();
          }
        });
    }
  }

  /**
   * @description recuperar los datos relacinados con el CIF
   */
  getDataBD(): void {
    this.clients.getClientes(this.FORM_DATA.get(this.FORM_CONFIG.documentNumber.linkFormPath).value)
      .pipe(take(1))
      .subscribe((client) => {
        if (client !== null) {
          this.setCIFData(client);
        }
      });
  }

  /**
   * @description limpiar y hablitar campos
   */
  enableData(): void {
    this.FORM_DATA.get(this.FORM_CONFIG.bussines.direction.linkFormPath).setValue('');
    this.FORM_DATA.get(this.FORM_CONFIG.direction.linkFormPath).setValue('');
    this.FORM_DATA.get(this.FORM_CONFIG.postalCode.linkFormPath).setValue('');
    this.FORM_DATA.get(this.FORM_CONFIG.telephone.linkFormPath).setValue('');
    this.FORM_DATA.get(this.FORM_CONFIG.email.linkFormPath).setValue('');
    this.FORM_DATA.get([this.insureSelected.chosed, 'insuredData', 'provinceId']).setValue('');
    this.Utils.enableInputs([this.disabledRazSo, this.disabledEmail, this.disabledPhone, this.disabledDir,
      this.disabledCP, this.disabledMuni, this.disabledProv, this.disabledSec]);
    this.sectorchange = { name: 'sector', value: { name: '', id: 0 } };
    this.Utils.munichange = { name: 'municipio', value: { name: '', id: 0 } };
  }

  /**
   * @description asignar los valores recuperados
   */
  setCIFData(data: any): void {
    this.Utils.idMunicipioRecuperado = data.idMunicipio;
    if (data.codPostal !== '') {
      this.getMunicipality(data.codPostal);
    }
    if (data.idSector !== null) {
      this.formDataValue.sectorList.forEach((item: any) => {
        if (item.id === data.idSector) {
          const auxSectorChange: any = { name: item.name, id: item.id };
          this.sectorchange = { name: 'sector', value: auxSectorChange };
        }
      });
    }

    this.FORM_DATA.get(this.FORM_CONFIG.bussines.direction.linkFormPath).setValue(data.nombreRazonSocial);
    this.FORM_DATA.get(this.FORM_CONFIG.direction.linkFormPath).setValue(data.direccion);
    this.FORM_DATA.get(this.FORM_CONFIG.postalCode.linkFormPath).setValue(data.codPostal);
    this.FORM_DATA.get(this.FORM_CONFIG.email.linkFormPath).setValue(data.email);
    this.Utils.enableInputs([this.disabledRazSo, this.disabledEmail, this.disabledPhone, this.disabledDir,
      this.disabledCP, this.disabledMuni, this.disabledProv, this.disabledSec]);

    if (data.nombreRazonSocial !== '') { this.disabledRazSo = true; }
    if (data.email !== '') { this.disabledEmail = true; }
    if (data.direccion !== '') { this.disabledDir = true; }
    if (data.idSector !== null) { this.disabledSec = true; }
    if (data.codPostal !== '') {
      this.disabledCP = true;
      this.disabledMuni = true;
      this.disabledProv = true;
    }
  }

  /**
   * @description changeCountry
   * @param event any
   */
  changeCountry(event: any): void {
    this.municipalitySrv.getMunicipalityNoSpain(event.id)
      .pipe(take(1))
      .subscribe((municipality) => {
        if (municipality !== null) {
          this.Utils.munichange = { name: 'municipio', value: municipality[0] };
          this.Utils.provchange = { name: 'provincia', value: '0' };
          this.cpchange = { name: 'cp', value: '0' };
          this.FORM_DATA.get([this.insureSelected.chosed, 'insuredData', 'postalCode']).setValue(0);
        } else {
          this.Utils.munichange = { name: 'municipio', value: 'error' };
          this.Utils.provchange = { name: 'provincia', value: 'error' };
          this.cpchange = { name: 'cp', value: 'error' };
          this.Utils.showModalDialog();
        }
      });
  }

  /**
   * @description changeMuni
   * @param event any
   */
  changeMuni(event: any): void {
    if (event.Des_Provincia !== undefined) {
      this.Utils.changeMuniUtils(event);
      this.FORM_DATA.get([this.insureSelected.chosed, 'insuredData', 'municipality'])
        .setValue({ name: event.Des_Municipio, id: event.Id_Municipio });
      this.FORM_DATA.get([this.insureSelected.chosed, 'insuredData', 'provinceId']).setValue(event.Id_Provincia);
    }
  }

  /**
   * @description dataEmit
   * @param ev any ev
   */
  dataEmit(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) { keyPress = ev; }
      if (keyPress !== null && keyPress.enter !== undefined && keyPress.enter) {
        const keyPressValue: any = keyPress.value;
        if (keyPressValue !== undefined) {
          this.setCIFData(keyPress.value);
        } else {
          this.getMunicipality(this.FORM_DATA.get(this.FORM_CONFIG.postalCode.linkFormPath).value);
        }
      }
    }
  }

  /**
   * @description dataEmitBlur
   * @param event any
   */
  dataEmitBlur(event: any): void {
    let keyValueControl = '';
    if (event.control !== undefined) { keyValueControl = event.control; }
    let keyValueName = '';
    if (event.fieldName !== undefined) { keyValueName = event.fieldName; }
    const auxValue: any = this.FORM_DATA.get(this.FORM_CONFIG.postalCode.linkFormPath).value;
    if (keyValueControl === 'check-document') {
    } else {
      if (this.formDataValue.countryOriginEnvironment === Numbers.number19001 && (auxValue === 0 || auxValue === '0')) {
        this.cpchange = { name: 'cp', value: 'error-spain' };
      }
      if (auxValue === '') {
        this.cpchange = { name: 'cp', value: 'error-empty' };
      }
    }
  }

  /**
   * checkInsuredChoosed
   * @returns returns
   */
  checkInsuredChoosed(): 'Particular' | 'Empresa' {
    return this.Utils.getInsuredChoosed(this.FORM_DATA, this.FORM_CONFIG);
  }
}
